import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {TimelineLite} from "gsap";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {PearlHarbor} from "../../PearlHarbor";
import {PearlHarborHelper} from "../../utils/PearlHarborHelper";


export class PearlHarborCocpitMultiplierUpdate implements FlowStatePresentation {
    private _tl: TimelineLite

    private skip(): void {
    }

    public shouldRun(): boolean {
        const isFs: boolean = PearlHarborHelper.isFreeSpin(PearlHarbor.model.data.mode);
        if (!isFs) {
            return false;
        }
        return (PearlHarbor.cocpitBoard.totalMulti < PearlHarbor.model.dogfight.totalMult);
    }

    private completePresentation(flowStateController: FlowStateController) {
        flowStateController.finish();
    }

    public start(flowStateController: FlowStateController): void {
        const winMulti:number = PearlHarbor.model.dogfight.kamakazi?(PearlHarbor.model.dogfight.totalMult/PearlHarbor.model.dogfight.kamikaziMult):PearlHarbor.model.dogfight.totalMult;
        this._tl = new TimelineLite();
        this._tl.add(() => flowStateController.setSkipCallback(() => this.skip()), 0.1);
        const addValue: number = winMulti - PearlHarbor.cocpitBoard.totalMulti;

        this._tl.add(() => PearlHarbor.cocpitBoard.updateCurrentRoundWin(true));
        this._tl.add(() => {}, 0.1);
        this._tl.add(() => this.completePresentation(flowStateController));
    }


}